// extracted by mini-css-extract-plugin
module.exports = {"change-value-container":"changeInValue_change-value-container__Tz62P","arrow":"changeInValue_arrow__3sphM","value-text":"changeInValue_value-text__3Bowy"};